import { render, staticRenderFns } from "./GeneratePago.vue?vue&type=template&id=ede876dc"
import script from "./GeneratePago.vue?vue&type=script&lang=js"
export * from "./GeneratePago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports